import { mapFeedDataFromResponse } from 'api/channel/mapFeedDataFromResponse'

export enum FeedTabs {
  FOR_YOU = 'For You',
  NEXT_UP = 'Next Up'
}

export type FeedQueryParams = {
  page: number
  per_page: number
  company?: string
  country_code?: string
  sport?: string
  parameters?: Record<string, any>
  channel?: any
}

export type FeedData = ReturnType<typeof mapFeedDataFromResponse>[0]

export enum FeedDataType {
  GAME = 'game',
  LIVESTREAM = 'livestream',
  VIDEO = 'video',
  ARTICLE = 'article'
}
